import ServiceStorage from "../../../../core/services/service.storage";
import _ from "lodash";
import ApiRegion from "../../../../core/api/api.region";
export default async function getData(city) {
  const storageCity = ServiceStorage.getCity();
  const cityLis =
    !_.isNil(storageCity) &&
    _.has(storageCity, "cityList") &&
    !_.isNil(storageCity.cityList)
      ? JSON.parse(storageCity?.cityList)
      : [];
  let cityListLastUpdateDays = 0;
  let cityListLastUpdate = new Date();
  if (!_.isNil(storageCity?.cityListLastUpdate)) {
    cityListLastUpdate = new Date(storageCity.cityListLastUpdate);
    const now = new Date();
    cityListLastUpdateDays = Math.floor(
      (Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) -
        Date.UTC(
          cityListLastUpdate.getFullYear(),
          cityListLastUpdate.getMonth(),
          cityListLastUpdate.getDate()
        )) /
        (1000 * 60 * 60 * 24)
    );
  }
  const newUpdateDate =
    cityListLastUpdateDays > 7 ? new Date() : cityListLastUpdate;
  const regoinResult =
    cityLis.length == 0 || cityListLastUpdateDays > 7
      ? await ApiRegion.getRegions()
      : cityLis;
  return { regoinResult, newUpdateDate };
}
